// import React, { useState } from "react";
// import { Helmet } from "react-helmet"; // Helmet import

import RandingStyle4 from "../../randing/RandingStyle4";

function Randing111({ urlCode, urlCodeSettingId }) {
  return (
    <RandingStyle4
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/111/250306_01.jpg`}
      img2Path={`${process.env.REACT_APP_CDN_BASE}/images/074/250114_02.jpg`}
      img3Path={`${process.env.REACT_APP_CDN_BASE}/images/111/250306_02.gif`}
      img4Path={`${process.env.REACT_APP_CDN_BASE}/images/111/250306_03.jpg`}
      img5Path={`${process.env.REACT_APP_CDN_BASE}/images/111/250306_04.jpg`}
      benefitInfoPosition="bottom"
      formFieldColor="white"
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/postBtns/blue/applyButton4.png`}
      companyName="본원"
      privacyMessage="개인정보수집에 동의하시는 분만 '신청하기'버튼을 눌러주세요."
      // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/woori2.jpg`}
    />
  );
}

export default Randing111;
